export default __webpack_public_path__ + "static/media/choix-mission-mobile.5d773a1b.jpg";